import { useCallback, useEffect, useRef, useState } from 'react';
import { MotionConfig, useReducedMotion } from 'framer-motion';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import './App.css';
import { Header, Hero } from './components/HeaderHero';
import { Practices, Story, Manifesto, Marquee } from './components/PracticeStory';
import { Testimonials, FAQ, ContactFooter } from './components/PeopleContact';
import { PracticePage, TeamPage, PersonPage } from './components/ContentPages';
import { practiceGuides } from './lib/practiceGuides';
import { FIRM, PRACTICE_CONTACT, team } from './lib/site';
import './components/ContentPages.css';
import { Consultation } from './components/Consultation';
import { DetailDialog } from './components/DetailDialog';
import { Receptionist } from './components/Receptionist';
import { AdminPage } from './components/AdminPage';
import { useVoice } from './hooks/useVoice';
import { Toaster } from './components/ui/sonner';
import { toast } from 'sonner';

export default function App() {
  if (window.location.pathname.startsWith('/admin')) return <AdminPage />;
  const path = window.location.pathname.replace(/\/index\.html$/, '').replace(/\/+$/, '') || '/';
  const guide = practiceGuides.find(item => path === `/practice-areas/${item.slug}`);
  const person = team.find(item => path === `/team/${item.id}`);
  return <Home guide={guide} person={person} isTeam={path === '/team'} />;
}

function Home({ guide, person, isTeam }) {
  const pageContact = guide ? { ...FIRM, ...PRACTICE_CONTACT } : FIRM;
  const [consultOpen, setConsultOpen] = useState(false);
  const [selectedArea, setSelectedArea] = useState('');
  const [detail, setDetail] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);
  const [readingPage, setReadingPage] = useState(false);
  const reduced = useReducedMotion();
  const lenis = useRef(null);
  const voice = useVoice();
  const stopVoice = voice.stop;
  useEffect(() => {
    if (reduced) return;
    const scroller = new Lenis({ autoRaf: true, duration: 1.15, anchors: { offset: -96 }, smoothWheel: true });
    lenis.current = scroller;
    return () => { scroller.destroy(); lenis.current = null; };
  }, [reduced]);
  useEffect(() => { if (consultOpen || detail || chatOpen) { lenis.current?.stop(); stopVoice(); setReadingPage(false); } else lenis.current?.start(); }, [consultOpen, detail, chatOpen, stopVoice]);
  useEffect(() => { if (!voice.speaking) setReadingPage(false); }, [voice.speaking]);
  const consult = useCallback((area = guide?.title || '') => { setDetail(null); setChatOpen(false); setSelectedArea(typeof area === 'string' ? area : ''); setConsultOpen(true); }, [guide]);
  const readPage = () => {
    if (readingPage) { voice.stop(); setReadingPage(false); return; }
    const content = [...document.querySelectorAll('main [data-read]')].map(el => el.innerText).join('. ');
    if (!voice.speak(`Welcome to Jos Legal Group. ${content}`)) { toast.error('Read-aloud is not supported in this browser.', { id: 'read-aloud-unavailable' }); return; }
    setReadingPage(true);
  };
  return <MotionConfig reducedMotion="user"><div className="legal-site"><a className="skip-link" href="#main-content" data-testid="skip-to-content">Skip to content</a><Header consult={consult} readPage={readPage} reading={readingPage} callContact={guide ? PRACTICE_CONTACT : undefined} /><main id="main-content" tabIndex={-1}>{guide ? <PracticePage guide={guide} guides={practiceGuides} firm={pageContact} consult={consult} /> : person ? <PersonPage person={person} team={team} firm={pageContact} consult={consult} /> : isTeam ? <TeamPage team={team} /> : <><Hero consult={consult} /><Practices consult={consult} /><Manifesto /><Testimonials /><Marquee /><Story consult={() => consult()} /><FAQ /></>}<ContactFooter contact={pageContact} callDirect={Boolean(guide)} consult={() => consult()} openPolicy={type => setDetail({ type })} openChat={() => setChatOpen(true)} /></main><Consultation contact={pageContact} open={consultOpen} onOpenChange={setConsultOpen} selectedArea={selectedArea} /><DetailDialog detail={detail} onClose={() => setDetail(null)} consult={consult} /><Receptionist contact={pageContact} open={chatOpen} onOpenChange={setChatOpen} consult={consult} openPrivacy={() => setDetail({ type: 'privacy' })} /><Toaster position="top-center" /></div></MotionConfig>;
}